import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6cc739f6")

_pushScopeId("data-v-6cc739f6")
const _hoisted_1 = { class: "lang" }
const _hoisted_2 = { class: "select-language" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _directive_click_outside_element = _resolveDirective("click-outside-element")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "lang__button button",
      onClick: _cache[1] || (_cache[1] = $event => ($setup.localActive = !$setup.localActive))
    }, [
      _createTextVNode(_toDisplayString($setup.changeLanguage) + " ", 1 /* TEXT */),
      _createVNode(_component_svg_icon, { name: "arrowdown2" })
    ]),
    _withDirectives(_createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.langs, (lang, langKey) => {
        return (_openBlock(), _createBlock("li", {
          key: langKey,
          onClick: $event => ($setup.switchLocal(langKey))
        }, _toDisplayString(lang), 9, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512), [
      [_vShow, $setup.localActive]
    ])
  ], 512)), [
    [_directive_click_outside_element, () => ($setup.localActive = false)]
  ])
})